import React from 'react';

import { Text } from '@BICE_Vida/components';

import { Container } from '@BICE_Vida/scp-components';

import styles from './PricesAndPlansDocuments.module.scss';

import { pricesAndPlansText } from '../../../utils/generalTexts';
import componentsId from '../../../utils/componentsId';
import { trackEvent } from '@/utils/dataLayer/baseDataLayer';
import { planPageEvents } from '@/utils/dataLayer/planPage';

function PricesAndPlansDocuments() {
  const handleClick = (title: string) => {
    trackEvent({
      eventParams: {
        ...planPageEvents.downloadClick(title),
      },
    });
  };

  return (
    <section
      id={componentsId.pricesAndPlans.documents.section}
      className={styles.prices_and_plans_documents_section}
    >
      <Container className={styles.prices_and_plans_documents_container}>
        <Text
          className={styles.prices_and_plans_documents_title}
          tag="h3"
          fontTypo="display-xsmall"
        >
          {pricesAndPlansText.documents.title}
        </Text>
        <div className={styles.prices_and_plans_documents_cards}>
          {pricesAndPlansText.documents.cards.map((card: any, index: number) => (
            <a
              id={`${componentsId.pricesAndPlans.documents.download}${index}`}
              key={`${componentsId.pricesAndPlans.documents.download}${index}`}
              href={card.pdf}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                handleClick(card.title);
              }}
            >
              <div className={styles.prices_and_plans_documents_card}>
                <div className={styles.prices_and_plans_documents_card_Text}>
                  <Text
                    className={styles.prices_and_plans_documents_card_title}
                    fontTypo="title-small"
                  >
                    {card.title}
                  </Text>
                  <Text className={styles.prices_and_plans_documents_card_size} fontTypo="caption">
                    {card.size}
                  </Text>
                </div>

                <img
                  src={pricesAndPlansText.documents.downloadIcon}
                  className={styles.prices_and_plans_documents_download_icon}
                  alt={pricesAndPlansText.documents.downloadIconAlt}
                />
              </div>
            </a>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default PricesAndPlansDocuments;
